module.exports = __webpack_public_path__ + "static/media/404.bed7fe14.svg";